import { useNavigate, useParams } from "react-router-dom";
import BreadCrum from "../basic/BreadCrum";
import { HeadingTitle, Paragraph } from "../basic/title";
import SingleBlog from "./SingleBlog";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getOnebLog, getBlog } from "../../../redux/slices/blog";

export default function SingleBlogDetails({
  allCategoriesData,
  categoryIsLoading,
  categoryError,
}) {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);

  const {
    isLoading: blogIsLoading,
    error: blogError,
    oneblog,
    allblog,
  } = useSelector((state) => state.blog);

  useEffect(() => {
    setLoading(true);
    dispatch(getOnebLog(id));
    dispatch(getBlog());
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, [dispatch, id]);

  const categoriDetailsRow = (id) => {
    navigate(`/categories/${id}`);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleDetailsRow = (id) => {
    navigate(`/blog/${id}`);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <BreadCrum
        componentName="Blog"
        link="/blog"
        componentSecondName="Blog Details"
      />

      <div className="container mx-auto max-w-7xl px-4 py-10">
        <div className="grid grid-cols-12 gap-8">
          {/* Main Blog Content */}
          <div className="md:col-span-8 lg:col-span-9 col-span-12">
            {blogIsLoading ? (
              <p className="text-center text-gray-500">Loading blog...</p>
            ) : blogError ? (
              <p className="text-center text-red-600">{blogError}</p>
            ) : (
              <SingleBlog onedata={oneblog} />
            )}
          </div>

          {/* Sidebar */}
          <div className="md:col-span-4 lg:col-span-3 col-span-12 space-y-10">
            {/* Categories */}
            <div>
              <HeadingTitle title="Categories" textAlign="left" />
              {categoryIsLoading || loading ? (
                [...Array(5)].map((_, index) => (
                  <div
                    key={index}
                    className="animate-pulse mt-2 flex justify-between py-2"
                  >
                    <div className="w-[150px] py-2 bg-gray-300 rounded"></div>
                    <div className="w-10 bg-gray-300 rounded"></div>
                  </div>
                ))
              ) : categoryError ? (
                <p className="text-red-600 font-medium">
                  Error loading categories
                </p>
              ) : (
                <ul className="divide-y divide-gray-200">
                  {allCategoriesData.map((row, index) => (
                    <li
                      key={index}
                      className="py-2 cursor-pointer hover:text-[#036642]"
                      onClick={() => categoriDetailsRow(row.id)}
                    >
                      {row.icon || "🛒"} {row.name}
                    </li>
                  ))}
                </ul>
              )}
            </div>

            {/* Latest Posts */}
            <div>
              <HeadingTitle title="Latest Posts" textAlign="left" />
              <div className="space-y-4 bg-white rounded-xl shadow p-4">
                {allblog.slice(0, 3).map((row, index) => (
                  <div
                    key={index}
                    onClick={() => handleDetailsRow(row.id)}
                    className="flex gap-4 items-start cursor-pointer hover:shadow-md transition duration-300 rounded-lg border p-2"
                  >
                    <div className="w-20 h-20 overflow-hidden rounded-md">
                      <img
                            src={row.image}
                            alt={row.title}
                            className="object-cover w-full h-full hover:scale-105 transition-transform duration-300"
                        />
                    </div>
                    <div className="flex-1">
                      <h3 className="text-sm font-semibold text-[#036642] mb-1">
                        {row.title}
                      </h3>
                      <p className="text-xs text-gray-500">{row.date}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
